import styled from 'styled-components'

export const ProjectsContainer = styled.div`
  display: flex;
  max-width: 1170px;
  gap: 80px;
  align-items: center;
  height: 700px;

  .container-img {
    display: flex;
    .slide {
      opacity: 0;
      transition: all 0.5s;
      transform: translateX(-30%) scale(0.95);

      &.active {
        opacity: 1;
        transform: translateX(0%) scale(1);
      }
    }
  }

  @media (max-width: 1265px) {
    padding: 0 67.5px;
  }

  @media (max-width: 1150px) {
    padding: 0 30px;
  }

  @media (max-width: 1050px) {
    flex-direction: column;
    padding: 0;
    height: 1050px;
    gap: 24px;
  }

  @media (max-width: 600px) {
    .title {
      font-size: 24px;
    }
    .description {
      font-size: 16px;
    }
  }
  @media (max-width: 500px) {
    padding: 0 16px;
    img {
      width: 100%;
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  height: 100%;

  .case-pagination {
    margin-top: auto;
  }
  @media (max-width: 1050px) {
    padding: 0 16px;
  }
`

export type ImageContainerProps = {
  width: number
  height: number
}

export const ImageContainer = styled.div<ImageContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;

  width: ${({ width }) => width};
  height: ${({ height }) => height};
`
